const { DateTime, } = require( "luxon" );

const nthWeekdayOfMonthCache = new Map();

// eslint-disable-next-line max-statements
exports.nthWeekdayOfMonth = ( {
	nth,
	weekday,
	month,
	year,
	timezone = "local",
	withUnmatched = true,
} ) => {
	const cacheKey = `${ nth },${ weekday },${ month },${ year },${ timezone },${ withUnmatched ? 1 : 0 }`;
	const cache = nthWeekdayOfMonthCache;
	if ( cache.has( cacheKey ) ) {
		return cache.get( cacheKey );
	}

	// eslint-disable-next-line no-magic-numbers
	month = `0${ month }`.slice( -2 );

	let current = DateTime.fromFormat( `${ year }-${ month }-01`, "yyyy-MM-dd", { zone: timezone, } )
		.startOf( "day" );
	const end = current.endOf( "month" )
		.startOf( "day" );

	let currentMS = current.toMillis();
	const endMS = end.toMillis();

	let weekdayInstance = 0;
	let found = false;
	let match = null;
	const unmatched = [];

	// TODO: this could probably be more efficient by skipping whole weeks
	do {
		if ( current.weekday === weekday ) {
			weekdayInstance += 1;
		}
		if ( weekdayInstance === nth && !found ) {
			found = true;
			match = current;
			// return early if we don't need to compute the rest
			// of the unmatched dates
			if ( !withUnmatched ) {
				break;
			}
		} else if ( withUnmatched ) {
			unmatched.push( current );
		}
		current = current.plus( { days: 1, } );
		currentMS = current.toMillis();
	} while ( currentMS <= endMS );

	const result = {
		match,
		unmatched,
	};
	cache.set( cacheKey, result );
	return result;
};

exports.nthWeekdayOfMonth.flushCache = () => nthWeekdayOfMonthCache.clear();
